import { render, staticRenderFns } from "./SkipChannel.vue?vue&type=template&id=7a0cc6d2&scoped=true"
import script from "./SkipChannel.vue?vue&type=script&lang=js"
export * from "./SkipChannel.vue?vue&type=script&lang=js"
import style0 from "./SkipChannel.vue?vue&type=style&index=0&id=7a0cc6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0cc6d2",
  null
  
)

export default component.exports